import React from 'react'
import { Div, Button, NavigationHeader } from '@driftt/tide-core'
import CSVImportLogs from './CSVImportLogs'

import './style.css'

const ImportLogs = props => {
  const { history } = props

  return (
    <Div className="import-logs--wrapper">
      <NavigationHeader title="Import accounts">
        <Button type="primary" onClick={() => history.push('/imports/new')}>New import</Button>
      </NavigationHeader>
      <CSVImportLogs/>
    </Div>
  )
}

export default ImportLogs
